export class OutputInfo {
  private _message: string;
  private _on: Date;

  private constructor(message: string) {
    this._message = message;
    this._on = new Date();
  }

  static create(message: string): OutputInfo {
    return new OutputInfo(message);
  }

  get message(): string {
    return this._message;
  }

  get on(): Date {
    return this._on;
  }

  toString(): string {
    return `[${this._on.toLocaleTimeString()}] - ${this._message}`;
  }
}
